import React from "react";
import AlanCredentialsAllPage from "../Components/AlanCredentials/AlanCredentialsPage";

const ViewAlanCredentialsPage = () => {
  return <AlanCredentialsAllPage />;
};

export default ViewAlanCredentialsPage;
